var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".home_svg__b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "home_svg__b",
    d: "M4 8.6V21h16V8.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "home_svg__b",
    d: "M2 10l10-7 10 7M15 21v-6a2 2 0 00-2-2h-2a2 2 0 00-2 2v6"
  })));
}

export default SvgHome;


//////////////////
// WEBPACK FOOTER
// ./src/icons/home.svg
// module id = 892
// module chunks = 101